var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar',{attrs:{"isWebView":_vm.isWebView,"routerLinks":_vm.routerLinks}}),_c('router-view',{staticClass:"router-view"}),_c('my-footer',{attrs:{"routerLinks":_vm.routerLinks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }